import React, { useEffect, useState } from "react"
import { Modal, Table, Spin, message } from "antd"
import OrderB2BService from "src/services/OrderB2BService"
import dayjs from "dayjs"

const PackageHistoryModal = ({ open, onClose, packageId }) => {
  const [loading, setLoading] = useState(false)
  const [history, setHistory] = useState([])

  const fetchHistory = async () => {
    if (!packageId.ID) return
    try {
      setLoading(true)
      const res = await OrderB2BService.getPackageHistory({
        package_id: packageId.ID,
        price: packageId.price_in || 0,
      })

      if (res.success) {
        const pkg = res.success

        // Lấy giá ban đầu
        const basePrice = Number(pkg.price_sell)

        // Ghép dữ liệu: thêm bản ghi gốc với update_count = 0
        const rawHistory = [
          {
            ID: `base-${pkg.ID}`,
            user_id: pkg.user_id || null,
            price: basePrice,
            update_count: 0,
            updated_at: pkg.created_at || pkg.updated_at,
          },
          ...(pkg.setting_packages || []),
        ]

        // Sắp xếp theo update_count tăng dần
        const sorted = rawHistory.sort(
          (a, b) => Number(a.update_count) - Number(b.update_count),
        )

        // Map thành dữ liệu cho Table
        let mapped = sorted.map((item, index, arr) => ({
          ID: item.ID,
          updated_by: item.user_id || "Hệ thống",
          old_price: index > 0 ? Number(arr[index - 1].price) : null,
          new_price: Number(item.price),
          updated_at: item.updated_at || item.created_at,
        }))

        // ✅ Loại bỏ record chỉ có giá ban đầu (không có old_price)
        mapped = mapped.filter(item => item.old_price !== null)

        setHistory(mapped)
      } else {
        setHistory([])
        message.warning("Không có lịch sử chỉnh sửa")
      }
    } catch (err) {
      console.error(err)
      message.error("Lỗi khi tải lịch sử gói cước")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (open) {
      fetchHistory()
    }
  }, [open, packageId])

  const columns = [
    // { title: "Người chỉnh sửa", dataIndex: "updated_by", key: "updated_by" },
    {
      title: "Giá cũ",
      dataIndex: "old_price",
      key: "old_price",
      render: val => val?.toLocaleString("en-US"),
    },
    {
      title: "Giá mới",
      dataIndex: "new_price",
      key: "new_price",
      render: val => val?.toLocaleString("en-US"),
    },
    {
      title: "Thời gian",
      dataIndex: "updated_at",
      key: "updated_at",
      render: val => (val ? dayjs(val).format("DD/MM/YYYY HH:mm") : ""),
    },
  ]

  return (
    <Modal
      open={open}
      title="Lịch sử chỉnh sửa gói cước"
      footer={null}
      onCancel={onClose}
      width={700}
    >
      <Spin spinning={loading}>
        <Table
          dataSource={history}
          columns={columns}
          rowKey="ID"
          pagination={false}
        />
      </Spin>
    </Modal>
  )
}

export default PackageHistoryModal
